import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bzvh3j6vb7: FaireBrandEntity = {
  token: "b_bzvh3j6vb7",
  type: "brand",
  name: "Rug & Weave Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/5be7e0da8547d50ed2f25a7ebf4499002f9bf9a046cc2e275e8475774fa513a0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/c1551731cc3a4d8f47858a8f3a26c96f743cd8142d9d8c0c68493b118f9d34cd.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5be7e0da8547d50ed2f25a7ebf4499002f9bf9a046cc2e275e8475774fa513a0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/c1551731cc3a4d8f47858a8f3a26c96f743cd8142d9d8c0c68493b118f9d34cd.jpeg",
  location: "Guelph, ON, CAN",
  minimumOrderDollars: 260,
  rating: 5,
  reviewCount: 23,
  isInsider: false,
  description:
    "\nSince the beginning, Rug & Weave has strived to add beauty and functionality to our customers homes through the items we carry. As we have grown over the years, we can proudly say that this philosophy is still at the core of everything we do. It’s not as much about what we carry, as it is about the everyday moments that are created around these objects in the home. Just like being curled up on the couch with one of our in-house made pillows, these moments and the feelings they inspire create the very fabric of your home.  We wanted to provide our high standard of quality and curated aesthetic.  With a wide range of textiles, this collection of pillows can inspire and help our customers tell the story of their lives and their home.\n\nWe aim to provide a carefully curated selection of throw pillows that will stand the test of time, and add meaning to your home. As decor enthusiasts ourselves, we hope to inspire you through our shop, voice, and aesthetic to feel prideful of the place where you do the most living. As a team, we’re constantly putting our heads together to broaden the brand, better serve our customers, and build a community of like-minded individuals who share a love for pieces that tell a remarkable story.\n\n",
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:11:36.482Z",
    importedBy: "entity-db-cli",
  },
};
